export var Experiments = {
    UnreadMessagesButtonDesktop: 'specs.chat.UnreadMessagesButtonDesktop',
    AllowSMSImages: 'specs.chat.AllowSMSImages',
    InstagramIntegration: 'specs.chat.AllowInstagramDeliveryMethod',
    HideBlackOnBlackBorder: 'specs.chat.HideBlackOnBlackBorder',
    NewBulkActions: 'specs.chat.NewBulkActions',
    InboxPikachu: 'specs.chat.InboxMobilePikachuIntegration',
    WSRNewColors: 'specs.chat.WSRNewColors',
};
//# sourceMappingURL=experiments.js.map